<template>
  <div class="">
    <div>
      <!--    <Header1/>-->

      <div v-if="isScrolled9">
        <Header1 />
      </div>

    <div class="index-box1">
      <div class="box">
        <h2 class="title">{{ $t('message.onlineExperience') }}</h2>
        <div @click="goPrice" class="but">
          <a class="fz_but">{{ $t('message.getPro') }}</a>
        </div>
        <!-- <h3 class="txt">标签field报错：缺少属性 aid 值，或文档ID不存在。</h3>
  {/eyou:arclist}
       <a href="/price/" class="pro">查看PRO版</a>

  <a href="http://119.29.162.214:8080/uploads/soft/20221201/Yasubit03.rar" download class="pro">软件下载</a> -->
        <!---->
        <div class="ibox">
          <div class="taowa">
            <div class="fzq_hmban">
              <div class="item">
                <i>
                  <img src="@/assets/newImage/1-2301091014163B.png" alt="" />
                </i>
                <span>{{ $t('message.originalImage') }}<br />960.44G</span>
              </div>
              <div class="item">
                <i>
                  <img :src="require('@/assets/newImage/1-230109101514525.png')" alt="" />
                </i>
                <span>{{ $t('message.compressed') }}<br />71.36G</span>
              </div>
              <div class="item">
                <i>
                  <img :src="require('@/assets/newImage/1-2301091015303J.png')" alt="" />
                </i>
                <span>{{ $t('message.saveSpace') }}<br />92.57%</span>
              </div>
            </div>
            <div class="c1">
              <div class="c2" @click="addImage">
                <div class="c3">
                  <el-upload class="c4 normal_upload" id="up_one" drag
                    action="http://192.168.10.50:8085:8080/yasubit/website/pictureCompress" :on-success="handleSuccess"
                    :before-upload="beforeUpload" ref="uploadRef" multiple accept=".jpg,.jpeg,.png,.webp"
                    :show-file-list="false" :auto-upload="false" :trigger="'click'"
                    @drop.native.prevent="($event) => { addImage(); }"
                    :headers="{ Authorization: 'Bearer ' + getToken() }">
                    <a href="javascript:;" @click.stop="addImage">
                      <div class="icon">
                        <img :src="require('@/assets/newImage/icon2.png')" alt="" />
                      </div>
                      <h3 class="ct1">{{ $t('message.imageCompress') }}</h3>
                    </a>
                    <div class="ct2">{{ $t('message.supportedImage') }}</div>
                    <div class="add add1" @click.stop="addImage">
                      <span class="s1"><img :src="require('@/assets/newImage/icon9.png')" alt="" /></span>
                      <span class="s2">{{ $t('message.addImage') }}</span>
                    </div>
                  </el-upload>
                </div>
              </div>
            </div>
            <div class="tips">
              {{ $t('message.visitorImageTip') }}
            </div>
          </div>
          <div class="taowa">
            <div class="fzq_hmban">
              <div class="item">
                <i>
                  <img :src="require('@/assets/newImage/1-230109101TJ40.png')" alt="" />
                </i>
                <span>{{ $t('message.originalVideo') }}<br />1.37G</span>
              </div>
              <div class="item">
                <i>
                  <img :src="require('@/assets/newImage/1-230109101ZR13.png')" alt="" />
                </i>
                <span>{{ $t('message.compressed') }}<br />128.99MB</span>
              </div>
              <div class="item">
                <i>
                  <img :src="require('@/assets/newImage/1-230109101936134.png')" alt="" />
                </i>
                <span>{{ $t('message.saveSpace') }}<br />90.79%</span>
              </div>
            </div>
            <div class="c1">
              <div class="c2" @click="addVideo">
                <div class="c3">
                  <el-upload class="c4 normal_upload" id="up_one" drag
                    action="http://192.168.10.50:8085:8080/yasubit/website/videoCompress" :on-success="handleSuccess"
                    :before-upload="beforeUpload" ref="uploadRef" multiple accept=".mp4,.avi,.mov,.wmv,.flv,.mkv"
                    :show-file-list="false" :auto-upload="false" :trigger="'click'"
                    @drop.native.prevent="($event) => { addVideo(); }"
                    :headers="{ Authorization: 'Bearer ' + getToken() }">
                    <a href="javascript:;" @click.stop="addVideo">
                      <div class="icon">
                        <img :src="require('@/assets/newImage/icon2.png')" alt="" />
                      </div>
                      <h3 class="ct1">{{ $t('message.videoCompress') }}</h3>
                    </a>
                    <div class="ct2">{{ $t('message.supportedVideo') }}</div>
                    <div class="add add1" @click.stop="addVideo">
                      <span class="s1"><img :src="require('@/assets/newImage/icon9.png')" alt="" /></span>
                      <span class="s2">{{ $t('message.addVideo') }}</span>
                    </div>
                  </el-upload>
                </div>
              </div>
            </div>
            <div class="tips">
              {{ $t('message.visitorVideoTip') }}
            </div>
          </div>
        </div>
      </div>
      <div class="mouse" onclick="topMao('#indexbox2')">
        <span>{{ $t('message.scrollDown') }}</span>
        <div class="icon">
          <img :src="require('@/assets/newImage/icon4.png')" alt="" />
        </div>
      </div>
    </div>
    <!-- 新增的模块 -->
    <div class="fhm-sec1">
      <div class="basecont">
        <div class="fz_tit basefont42">{{ $t('message.localCompressSoftware') }}</div>
        <div class="cont">
          <div class="f_img baseimg">
            <img :src="require('@/assets/newImage/1-230109102A5I2.gif')" alt="" />
          </div>
          <div class="f_font">
            <div class="fz_jut">
              <div class="f_li">
                <i><img :src="require('@/assets/newImage/1-230109102934646.png')" alt="" /></i>
                <span>{{ $t('message.noFileLimit') }}</span>
              </div>
              <div class="f_li">
                <i><img :src="require('@/assets/newImage/1-230109102950507.png')" alt="" /></i>
                <span>{{ $t('message.vipRights') }}</span>
              </div>
              <div class="f_li">
                <i><img :src="require('@/assets/newImage/1-23010910300A45.png')" alt="" /></i>
                <span>{{ $t('message.customCompress') }}</span>
              </div>
              <div class="f_li">
                <i><img :src="require('@/assets/newImage/1-230109103024324.png')" alt="" /></i>
                <span>{{ $t('message.folderOneClick') }}</span>
              </div>
            </div>
            <div class="but">
              <a href="https://www.yasubit.com/uploads/soft/20230630/Yasubit (x86).zip" dow class="f_but fzajax">
                <i><img :src="require('@/assets/newImage/windowicon1.png')" alt="" /></i>
                <span>{{ $t('message.windows32') }}</span>
              </a>
              <a href="https://www.yasubit.com/uploads/soft/20230630/Yasubit (x64).zip" dow class="f_but fzajax">
                <i><img :src="require('@/assets/newImage/windowicon1.png')" alt="" /></i>
                <span>{{ $t('message.windows64') }}</span>
              </a>
            </div>
            <div class="f_text">
              {{ $t('message.selectedUsers') }}<span class="fzshu">383046</span>{{ $t('message.users') }}</div>
          </div>
        </div>
      </div>
    </div>


    <div class="index-box4">
      <div class="box">
        <h2 class="title">{{ $t('message.ourPartners') }}</h2>
        <div class="lbox" v-if="isScrolled">
          <div class="move1" :class="{ animated: showAnimation }">
            <div class="img img1 wow fadeInUp" data-wow-delay="0.2s">
              <img :src="require('@/assets/newImage/1-210P6115545540.png')" alt="" />
            </div>
          </div>
          <div class="move2" :class="{ animated: showAnimation }">
            <div class="img img2 wow fadeInUp" data-wow-delay="0.4s">
              <img :src="require('@/assets/newImage/1-210P6115625C7.png')" alt="" />
            </div>
          </div>
          <div class="move3" :class="{ animated: showAnimation }">
            <div class="img img3 wow fadeInUp" data-wow-delay="0.6s">
              <img :src="require('@/assets/newImage/1-210P6115AD20.png')" alt="" />
            </div>
          </div>
          <div class="move4" :class="{ animated: showAnimation }">
            <div class="img img4 wow fadeInUp" data-wow-delay="0.8s">
              <img :src="require('@/assets/newImage/1-210604104S25B.png')" alt="" />
            </div>
          </div>
          <div class="move5" :class="{ animated: showAnimation }">
            <div class="img img5 wow fadeInUp" data-wow-delay="1s">
              <img :src="require('@/assets/newImage/1-210604104Z5210.png')" alt="" />
            </div>
          </div>
          <div class="move6" :class="{ animated: showAnimation }">
            <div class="img img6 wow fadeInUp" data-wow-delay="1.2s">
              <img :src="require('@/assets/newImage/1-21060410492aO.png')" alt="" />
            </div>
          </div>
          <div class="move7" :class="{ animated: showAnimation }">
            <div class="img img7 wow fadeInUp" data-wow-delay="1.4s">
              <img :src="require('@/assets/newImage/1-210513100U93E.png')" alt="" />
            </div>
          </div>
          <div class="move8" :class="{ animated: showAnimation }">
            <div class="img img8 wow fadeInUp" data-wow-delay="1.6s">
              <img :src="require('@/assets/newImage/1-210513100S9341.png')" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
      <Footer />
      <!-- Use the new ImageCompress component -->
      <image-compress :image-open="imageOpen" @close="closeImageDialog" @minimize="minimizeImageDialog"></image-compress>
      <VideoCompress :videoOpen="videoOpen" @close="videoOpen = false" @minimize="minimizeVideo" />
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import Footer from "@/views/footer.vue";
import Header from "@/views/header.vue";
import Header1 from "@/views/header1.vue";
import ImageCompress from '@/components/ImageCompress.vue';
import VideoCompress from '@/components/VideoCompress.vue';
import axios from "axios";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import EventBus from "@/assets/js/event-bus.js";

export default {
  name: "",
  components: {
    Header,
    Header1,
    Footer,
    swiper,
    swiperSlide,
    ImageCompress,
    VideoCompress
  },
  data() {
    return {
      uploadedFiles: [],
      isScrolled: false,
      isScrolled9: true,
      data1: "",
      data2: "",
      data3: "",
      data4: [],
      data5: [],
      data6: [],
      // 上传的图片列表
      // 0显示灰色的开始压缩，1显示蓝色的开始压缩，2显示下载全部
      // 图片压缩弹窗
      imageOpen: false,
      videoOpen: false,
      fileList: [
        {
          name: "food.jpeg",
          url: "https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100",
        },
        {
          name: "food2.jpeg",
          url: "https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100",
        },
      ],
      showAnimation: false,
      isTop: true,
      data: null,
      loading: true,
      caseList: [],
      newsList: [],
      swiperOption: {
        notNextTick: true, //notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        direction: "vertical", //水平方向移动
        grabCursor: true, //鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
        setWrapperSize: true, //Swiper使用flexbox布局(display: flex)，开启这个设定会在Wrapper上添加等于slides相加的宽或高，在对flexbox布局的支持不是很好的浏览器中可能需要用到。
        autoHeight: true, //自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化
        slidesPerView: 1, //设置slider容器能够同时显示的slides数量(carousel模式)。可以设置为数字（可为小数，小数不可loop），或者 'auto'则自动根据slides的宽度来设定数量。loop模式下如果设置为'auto'还需要设置另外一个参数loopedSlides。
        mousewheel: true, //开启鼠标滚轮控制Swiper切换。可设置鼠标选项，默认值false
        mousewheelControl: true, //同上
        height: window.innerHeight - 60, // 高度设置，占满设备高度
        resistanceRatio: 0, //抵抗率。边缘抵抗力的大小比例。值越小抵抗越大越难将slide拖离边缘，0时完全无法拖离。本业务需要
        observeParents: true, //将observe应用于Swiper的父元素。当Swiper的父元素变化时，例如window.resize，Swiper更新

        // 如果自行设计了插件，那么插件的一些配置相关参数，也应该出现在这个对象中，如下debugger
        //debugger: true,

        // swiper的各种回调函数也可以出现在这个对象中，和swiper官方一样
        on: {
          //监听滑动切换事件，返回swiper对象
          // slideChange: () => {
          //   let swiper = this.$refs.mySwiper.swiper;
          //   //console.log(swiper.activeIndex); //滑动打印当前索引
          //   if (swiper.activeIndex === this.list.length - 1) {
          //     //到最后一个加载更多数据
          //     let newList = [];
          //     let listLength = this.list.length;
          //     for (let i = 0; i < 10; i++) {
          //       newList.push(listLength + i);
          //     }
          //     this.list = this.list.concat(newList);
          //   }
          // }
        },
      },
    };
  },

  created() {
    // 当app.vue点击侧边栏的图片压缩，打开弹窗
    EventBus.$on("openDialog", () => {
      this.imageOpen = true;
    });
  },
  methods: {
    goPrice() {
      this.$router.push({ path: "price" });
    },
    handleScroll9() {

      // 获取当前滚动位置
      const scrollY = window.scrollY || window.pageYOffset;
      // 可以设置一个阈值来确定何时改变isScrolled9的值
      const dis = 100;

      // 判断滚动位置是否大于阈值
      if (scrollY > dis) {
        // 向下滚动，将isScrolled9设为false

        this.isScrolled9 = false;
      } else {
        // 向上滚动，将isScrolled9设为true

        this.isScrolled9 = true;
      }

      // const scrollDistance = window.scrollY || document.documentElement.scrollTop;

      // // 当滚动距离小于等于200px时，设置isScrolled9为true

      // this.isScrolled9 = scrollDistance <=500;
    },

    // 关闭图片压缩的弹窗，清空所有下载和压缩任务
    closeDialog() {
      this.imageOpen = false;
      this.imageDataList = [];
      this.status = 0;
      this.$emit("my-event2");
    },
    // 最小化弹窗，显示在侧边栏
    minimizeDialog() {
      this.imageOpen = false;
      this.$emit("my-event");
    },
    // 如果压缩完了，将按钮改为全部下载
    isFinish() {
      const checkFinish = setInterval(() => {
        this.status = 0;
        // 判断datalist中所有item的finish属性是否都为true
        const allFinish = this.imageDataList.every((item) => item.finish);
        if (allFinish) {
          // 将status修改为2
          this.status = 2;
          // 停止检查
          clearInterval(checkFinish);
        }
      }, 500); // 每隔500毫秒检查一次
    },
    getToken() {
      return localStorage.getItem("loginToken");
    },
    // 获取用户信息
    async getUserInfo() {
      const token = localStorage.getItem("loginToken");
      const headers = { Authorization: `Bearer ` + token };
      this.$refs.uploadRef.headers = headers;
      try {
        // 刷新用户信息
        this.$http.get("yasubit/users/refresh", { headers });
        const response = await this.$http.get("yasubit/users/lastInfo", {
          headers,
        });
        // 未登录
        if (response.data.code !== 200) {
          return null;
        }
        // 判断是否为普通用户
        return response.data.data.setMeal;
      } catch (error) {
        console.error("Error fetching data:", error);
        throw error;
      }
    },
    // 上传图片
    async beforeUpload(file) {
      // console.log("file", file.name);
      if (this.imageDataList.find((item) => item.fileName === file.name)) {
        this.$message.error("该图片已存在");
        return;
      }
      // 如果文件超过5MB，判断是否是会员
      if (file.size > 5 * 1024 * 1024) {
        const meal = await this.getUserInfo();
        // 未登录(meal=null)，普通用户(meal=5)
        if (meal === null || meal.length === 0 || meal === 5) {
          this.$message.error("非会员上传文件不能超过5MB");
          return;
        }
      }

      // 显示图片信息
      this.imageDataList.push({
        progress: 0,
        finish: false,
        fileName: file.name,
        size: file.size,
      });
      await this.startProgressAnimation(this.imageDataList.length - 1); // 开始进度条动画
      const allowedFormats = [
        "image/jpeg",
        "image/jpeg",
        "image/webp",
        "image/png",
      ];
      const isAllowedFormat = allowedFormats.includes(file.type);
      if (!isAllowedFormat) {
        this.$message.error("上传图片只能是 JPG/JPEG/WEBP/PNG 格式!");
      }
      return isAllowedFormat;
    },
    // 压缩完成
    handleSuccess(response, file, fileList) {

      // console.log(response);
      // if (response.code !== 200) {
      //   this.$message.error(response.msg);
      // }
      const item = this.imageDataList.find(
        (item) => item.fileName === file.name
      );
      item.finish = true;
      Object.assign(item, response.data);
      // this.allowDownload = true;
    },
    // 进度条
    startProgressAnimation(index) {
      const interval = 30; // 每次递增的时间间隔（单位：毫秒）
      const maxProgress = 100; // 进度条的最大值
      const imageSize = this.imageDataList[index].size; // 图片大小
      let currentProgress = 0;
      const incrementalProgress = Math.ceil(maxProgress / (imageSize / 1024)); // 每次递增的进度值
      const progressTimer = setInterval(() => {
        currentProgress += incrementalProgress;
        if (currentProgress >= maxProgress) {
          clearInterval(progressTimer); // 达到最大值时停止定时器
          this.status = 1;
        }
        this.$set(this.imageDataList[index], "progress", currentProgress); // 更新进度条的进度
      }, interval);
    },

    downloadImage(index) {
      const row = this.imageDataList[index];
      this.$http
        .get("yasubit/website/downloadFile", {
          params: { fileName: row.compressUrl },
          responseType: "arraybuffer",
        })
        .then((response) => {
          const fileExt = row.fileName.split(".").pop();
          const blob = new Blob([response.data], { type: "image/" + fileExt }); // 创建一个下载链接

          const downloadLink = document.createElement("a");
          downloadLink.href = window.URL.createObjectURL(blob);
          downloadLink.download = row.fileName; // 将链接添加到页面，并模拟点击触发下载

          document.body.appendChild(downloadLink);
          downloadLink.click(); // 移除链接

          document.body.removeChild(downloadLink);
        });
    },
    deleteImage(index) {
      this.imageDataList.splice(index, 1);
    },
    downloadAll() {
      const zip = new JSZip();
      // 下载所有图片添加到JSZip，生成一个压缩文件
      const downloadPromises = this.imageDataList.map((row) => {
        return this.$http
          .get("yasubit/website/downloadFile", {
            params: { fileName: row.compressUrl },
            responseType: "arraybuffer",
          })
          .then((response) => {
            const fileExt = row.fileName.split(".").pop();
            zip.file(row.fileName, response.data, { binary: true });
          });
      });
      // 当downloadPromises所有请求完成后
      Promise.all(downloadPromises)
        .then(() => {
          // 生成一个压缩文件，并将其保存在一个Blob对象中
          return zip.generateAsync({ type: "blob" });
        })
        .then((content) => {
          const currentDate = new Date();
          const formattedDate = currentDate
            .toISOString()
            .replace(/:/g, "")
            .replace(/-/g, "")
            .split(".")[0];
          const fileName = `Yasubit-${formattedDate}.7z`;
          // Blob对象作为文件下载到本地
          saveAs(content, fileName);
        });
    },
    // 打开压缩弹窗就点击elementui的上传组件
    addImage() {
      this.imageOpen = true;
    },
    addVideo() {
      this.videoOpen = true;
    },

    getchData() {
      // 定义请求头，替换 'YourAuthToken' 为你的有效身份验证令牌
      const headers = {};

      // 发送 GET 请求并在请求中添加自定义请求头
      this.$http
        .get("yasubit/website/91", { headers })
        .then((response) => {
          // 请求成功时更新数据

          //图片
          // this.data1 = response.data.data[3].archiveList[0].litpic
          this.data1 = response.data.data[0].children[4].typename;
          this.data2 = response.data.data[0].children[3].typename;
          this.data3 = response.data.data[0].children[0].typename;


        })
        .catch((error) => {
          // 请求失败时处理错误
          console.error("Error fetching data:", error);
        });
      // // 发送 GET 请求
      // this.$http.get('/system/user/deptTree')
      //     .then(response => {
      //       // 请求成功时更新数据
      //       1111111111)
      //       // this.data = response.data;
      //     })
      //     .catch(error => {
      //       // 请求失败时处理错误
      //       console.error('Error fetching data:', error);
      //     });
    },

    // 图片上传
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length
        } 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },

    handleScroll1() {
      // console.log("正在滚动！");
      // // 获取页面总高度
      // const totalPageHeight = document.documentElement.scrollHeight - window.innerHeight;
      //
      // // 获取滚动条距离顶部的距离
      // const scrollDistance = window.scrollY || document.documentElement.scrollTop;
      //
      // // 设置百分比触发条件，例如滚动距离达到总高度的30%
      // const triggerPercentage = 80;
      // const triggerDistance = (triggerPercentage / 100) * totalPageHeight;
      //
      // // 当滚动距离大于等于触发距离时，设置isScrolled为true
      // this.isScrolled = scrollDistance >= triggerDistance;
      // 获取滚动条距离顶部的距离
      const scrollDistance =
        window.scrollY || document.documentElement.scrollTop;

      // 当滚动距离大于等于500px时，设置isScrolled为true
      this.isScrolled = scrollDistance >= 950;
      // console.log("距离");
      // console.log(this.isScrolled);
    },

    handleScroll() {
      // 判断是否滚动到页面顶部
      this.isTop = window.scrollY === 0;
    },
    getDownloadList() {
      const headers = {
        Authorization:
          "Bearer eyJhbGciOiJIUzUxMiJ9.eyJsb2dpbl91c2VyX2tleSI6IjBhNDUxNTgyLTZiMjYtNDUzNy1hN2NjLTQ5OTIzMjg0NWEzMSJ9.HTkalwe0xlA8sPIDk143-c4vaxBtbnHPlMPDLdeEi9xm_9fYrgdBuZnArlXl9d1HJia9VWDcLU8Fl_uuKyvEhQ",
      };
      const queryParams = {
        resourceType: 3,
      };

      // 发送 GET 请求并在请求中添加自定义请求头
      this.$http
        .get("yasubit/website/download", {
          headers,
          params: queryParams,
          responseType: "arraybuffer",
        })
        .then((response) => {
          // 请求成功时更新数据

          // 创建一个 Blob 对象，将二进制数据包装成文件
          const blob = new Blob([response.data], {
            type: "application/zip; charset=UTF-8",
          });

          // 创建一个下载链接
          const downloadLink = document.createElement("a");
          downloadLink.href = window.URL.createObjectURL(blob);
          downloadLink.download = "Supported Cameras.zip";

          // 将链接添加到页面，并模拟点击触发下载
          document.body.appendChild(downloadLink);
          downloadLink.click();

          // 移除链接
          document.body.removeChild(downloadLink);
          // this.data = response.data;
        })
        .catch((error) => {
          // 请求失败时处理错误
          console.error("Error fetching data:", error);
        });
    },
    getDownloadPublic() {
      const headers = {
        Authorization:
          "Bearer eyJhbGciOiJIUzUxMiJ9.eyJsb2dpbl91c2VyX2tleSI6IjBhNDUxNTgyLTZiMjYtNDUzNy1hN2NjLTQ5OTIzMjg0NWEzMSJ9.HTkalwe0xlA8sPIDk143-c4vaxBtbnHPlMPDLdeEi9xm_9fYrgdBuZnArlXl9d1HJia9VWDcLU8Fl_uuKyvEhQ",
      };
      const queryParams = {
        resourceType: 4,
      };

      // 发送 GET 请求并在请求中添加自定义请求头
      this.$http
        .get("yasubit/website/download", {
          headers,
          params: queryParams,
          responseType: "arraybuffer",
        })
        .then((response) => {
          // 请求成功时更新数据

          // 创建一个 Blob 对象，将二进制数据包装成文件
          const blob = new Blob([response.data], {
            type: "application/zip; charset=UTF-8",
          });

          // 创建一个下载链接
          const downloadLink = document.createElement("a");
          downloadLink.href = window.URL.createObjectURL(blob);
          downloadLink.download = "Rawbaker(公测版).zip";

          // 将链接添加到页面，并模拟点击触发下载
          document.body.appendChild(downloadLink);
          downloadLink.click();

          // 移除链接
          document.body.removeChild(downloadLink);
          // this.data = response.data;
        })
        .catch((error) => {
          // 请求失败时处理错误
          console.error("Error fetching data:", error);
        });
    },
    getDownload32() {
      const headers = {
        Authorization:
          "Bearer eyJhbGciOiJIUzUxMiJ9.eyJsb2dpbl91c2VyX2tleSI6IjBhNDUxNTgyLTZiMjYtNDUzNy1hN2NjLTQ5OTIzMjg0NWEzMSJ9.HTkalwe0xlA8sPIDk143-c4vaxBtbnHPlMPDLdeEi9xm_9fYrgdBuZnArlXl9d1HJia9VWDcLU8Fl_uuKyvEhQ",
      };
      const queryParams = {
        resourceType: 2,
      };

      // 发送 GET 请求并在请求中添加自定义请求头
      this.$http
        .get("yasubit/website/download", {
          headers,
          params: queryParams,
          responseType: "arraybuffer",
        })
        .then((response) => {
          // 请求成功时更新数据

          // 创建一个 Blob 对象，将二进制数据包装成文件
          const blob = new Blob([response.data], {
            type: "application/zip; charset=UTF-8",
          });

          // 创建一个下载链接
          const downloadLink = document.createElement("a");
          downloadLink.href = window.URL.createObjectURL(blob);
          downloadLink.download = "Yasubit(x86).zip";

          // 将链接添加到页面，并模拟点击触发下载
          document.body.appendChild(downloadLink);
          downloadLink.click();

          // 移除链接
          document.body.removeChild(downloadLink);
          // this.data = response.data;
        })
        .catch((error) => {
          // 请求失败时处理错误
          console.error("Error fetching data:", error);
        });
    },
    getDownload64() {
      const headers = {
        Authorization:
          "Bearer eyJhbGciOiJIUzUxMiJ9.eyJsb2dpbl91c2VyX2tleSI6IjBhNDUxNTgyLTZiMjYtNDUzNy1hN2NjLTQ5OTIzMjg0NWEzMSJ9.HTkalwe0xlA8sPIDk143-c4vaxBtbnHPlMPDLdeEi9xm_9fYrgdBuZnArlXl9d1HJia9VWDcLU8Fl_uuKyvEhQ",
      };
      const queryParams = {
        resourceType: 1,
      };

      // 发送 GET 请求并在请求中添加自定义请求头
      this.$http
        .get("yasubit/website/download", {
          headers,
          params: queryParams,
          responseType: "arraybuffer",
        })
        .then((response) => {
          // 请求成功时更新数据

          // 创建一个 Blob 对象，将二进制数据包装成文件
          const blob = new Blob([response.data], {
            type: "application/zip; charset=UTF-8",
          });

          // 创建一个下载链接
          const downloadLink = document.createElement("a");
          downloadLink.href = window.URL.createObjectURL(blob);
          downloadLink.download = "Yasubit(x64).zip";

          // 将链接添加到页面，并模拟点击触发下载
          document.body.appendChild(downloadLink);
          downloadLink.click();

          // 移除链接
          document.body.removeChild(downloadLink);
          // this.data = response.data;
        })
        .catch((error) => {
          // 请求失败时处理错误
          console.error("Error fetching data:", error);
        });
    },

    Price() {

      // this.$router.push({path:'GoIn'})
    },
    fetchData() {
      // 定义请求头，替换 'YourAuthToken' 为你的有效身份验证令牌
      const headers = {
        // 'Authorization': 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJsb2dpbl91c2VyX2tleSI6IjEyMDkwYjRkLTdmZmYtNDFjNC05Yjk1LWRiOTMwZjRlYzA4YiJ9.pj2sxei6q_VIuHNvIelIJWqIso-JULIhR-unG0M0Wfcw9sX-evwM-FaVOFRAdoUewynuhvK-mdfHXoDay4a4pw',
        // // 可以添加其他自定义请求头
        // // 'Custom-Header': 'YourCustomHeaderValue',
      };

      // 发送 GET 请求并在请求中添加自定义请求头
      this.$http
        .get("yasubit/website/{}", { headers })
        .then((response) => {
          // 请求成功时更新数据

          // this.data = response.data;
        })
        .catch((error) => {
          // 请求失败时处理错误
          console.error("Error fetching data:", error);
        });
      // // 发送 GET 请求
      // this.$http.get('/system/user/deptTree')
      //     .then(response => {
      //       // 请求成功时更新数据
      //       console.log(1111111111)
      //       // this.data = response.data;
      //     })
      //     .catch(error => {
      //       // 请求失败时处理错误
      //       console.error('Error fetching data:', error);
      //     });
    },
    // 如果你需要得到当前的swiper对象来做一些事情，你可以像下面这样定义一个方法属性来获取当前的swiper对象，同时notNextTick必须为true
    computed: {
      swiper() {
        return this.$refs.mySwiper.swiper;
      },
    },
    closeImageDialog() {
      this.imageOpen = false;
      // Optionally emit an event to the parent if needed
      // this.$emit('my-event2');
    },
    minimizeImageDialog() {
      this.imageOpen = false;
      // Optionally emit an event to the parent if needed
      // this.$emit('my-event');
    },
    minimizeVideo() {
      this.videoOpen = false;
    }
  },
  mounted() {
    // 滚动到顶部
    window.scrollTo(0, 0);
    // 监听滚动事件
    // window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("scroll", this.handleScroll9);
    window.addEventListener("scroll", this.handleScroll1);
    // 初始化时检查滚动位置
    // this.handleScroll();

    // this.getchData();

    // 加载其他数据
    // this.$http
    //   .all([
    //     this.$http.get("Cases/GetCasesAll"),
    //     this.$http.get(`News?type=1&num=3`),
    //   ])
    //   .then(
    //     this.$http.spread((responseCases, responseNews) => {
    //       this.caseList = responseCases.data;
    //       this.newsList = responseNews.data;
    //     })
    //   );
    // this.$http
    //   .all([
    //     this.$http.get("Cases/GetCasesAll"),
    //     this.$http.get(`News?type=1&num=3`),
    //   ])
    //   .then(
    //     this.$http.spread((responseCases, responseNews) => {
    //       this.caseList = responseCases.data;
    //       this.newsList = responseNews.data;
    //       this.loading = false;
    //     })
    //   );
    // this.$http
    //   .all([
    //     this.$http.get("Cases/GetCasesAll"),
    //     this.$http.get(`News?type=1&num=3`),
    //   ])
    //   .then(
    //     this.$http.spread((responseCases, responseNews) => {
    //       this.caseList = responseCases.data;
    //       this.newsList = responseNews.data;
    //       this.loading = false;
    //     })
    //   );
  },
};
</script>

<style lang="scss" scoped>
/* 在全局样式中或者在合适的地方添加以下样式 */
body {
  overflow: hidden;
  /* 隐藏body元素的滚动条 */
}

//.change1::before {
//  content: "";  /* 伪元素内容为空 */
//  position: absolute;  /* 绝对定位相对于包含它的 .el-upload__text 元素 */
//  top: 0;
//  left: -100%;  /* 初始位置在左侧以实现从左到右的效果 */
//  width: 200%;  /* 背景大小为原始宽度的两倍，以便在动画过程中能完全覆盖 */
//  height: 100%;
//  background: linear-gradient(to right, #6fb0ff 50%,#ffffff 50%,#ffffff 50%);
//  transition: left 1s linear;  /* 持续一秒的线性过渡 */
//}
//.change1:hover::before {
//  left: 100%;  /* 当鼠标悬停时，将伪元素移动到最右侧，显示完整的渐变效果 */
//}
//.change1 {
//  position: relative;  /* 为了设置伪元素的绝对定位 */
//  overflow: hidden;    /* 隐藏溢出的渐变效果 */
//}

.move1 {
  opacity: 0; // 初始时透明度为0，隐藏元素
  animation: fadeIn 1s forwards, moveUp 1s forwards; // 1s 表示动画持续时间，forwards 表示动画结束后保持最终状态
}

.move2 {
  opacity: 0; // 初始时透明度为0，隐藏元素
  animation: fadeIn 2s forwards, moveUp 1s forwards; // 1s 表示动画持续时间，forwards 表示动画结束后保持最终状态
}

.move3 {
  opacity: 0; // 初始时透明度为0，隐藏元素
  animation: fadeIn 3s forwards, moveUp 0.5s forwards; // 1s 表示动画持续时间，forwards 表示动画结束后保持最终状态
}

.move4 {
  opacity: 0; // 初始时透明度为0，隐藏元素
  animation: fadeIn 4s forwards, moveUp 1s forwards; // 1s 表示动画持续时间，forwards 表示动画结束后保持最终状态
}

.move5 {
  opacity: 0; // 初始时透明度为0，隐藏元素
  animation: fadeIn 4.5s forwards, moveUp 1.5s forwards; // 1s 表示动画持续时间，forwards 表示动画结束后保持最终状态
}

.move6 {
  opacity: 0; // 初始时透明度为0，隐藏元素
  animation: fadeIn 5s forwards, moveUp 2.5s forwards; // 1s 表示动画持续时间，forwards 表示动画结束后保持最终状态
}

.move7 {
  opacity: 0; // 初始时透明度为0，隐藏元素
  animation: fadeIn 5.5s forwards, moveUp 3s forwards; // 1s 表示动画持续时间，forwards 表示动画结束后保持最终状态
}

.move8 {
  opacity: 0; // 初始时透明度为0，隐藏元素
  animation: fadeIn 6s forwards, moveUp 3.5s forwards; // 1s 表示动画持续时间，forwards 表示动画结束后保持最终状态
}

@keyframes moveUp {
  to {
    transform: translateY(-10px); // 向上移动 px
  }
}

@keyframes fadeIn {
  to {
    opacity: 1; // 最终透明度为1，显示元素
  }
}

#movingBox {
  transition: transform 0.5s ease; // 添加过渡效果
}

.bounce-animation {
  animation: bounce 2s infinite;
}

@keyframes bounce {

  0%,
  20%,
  50%,
  80%,
  100% {
    transform: translateY(0); // 初始位置和结束位置
  }

  40% {
    transform: translateY(-15px); // 上抬的高度，可以根据需要修改
  }

  60% {
    transform: translateY(-15px); // 下压的高度，可以根据需要修改
  }
}

.box1 {
  width: 100%;

  //background-image: url("../../src/assets/img/shouyebag.png");
  /* 替换 'your-image.jpg' 为你的背景图片路径 */
  //background-size: auto 50%; /* 背景图片宽度自适应，高度占据50% */
  background-repeat: no-repeat;
}

.drop-area {
  border: 2px dashed #ccc;
  padding: 20px;
  cursor: pointer;
}

.drop-area p {
  margin: 0;
}

.drop-area:hover {
  border-color: #333;
}

.case {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  //background-image: url('../../src/assets/img/shouyebag.png'); /* 替换 'your-image.jpg' 为你的背景图片路径 */
  ////background-size: auto 50%; /* 背景图片宽度自适应，高度占据50% */
  //background-repeat: no-repeat;
}

.bg {
  //padding-top: 50px;
  width: 100%;
  /* 设置盒子宽度 */
  /* 设置盒子高度 */
  //background-image: url("../../src/assets/img/shouyebag.png");
  /* 替换 'your-image.jpg' 为你的背景图片路径 */
  //background-size: auto 50%; /* 背景图片宽度自适应，高度占据50% */
  background-repeat: no-repeat;
  background-size: cover;
  /* 让背景图片覆盖整个盒子 */
  background-position: center;
  /* 将背景图片居中 */
}

.bg1 {
  //padding-top: 50px;
  width: 100%;
  /* 设置盒子宽度 */
  /* 设置盒子高度 */
  //background-image: url("../../src/assets/img/shouyebag.png");
  /* 替换 'your-image.jpg' 为你的背景图片路径 */
  //background-size: auto 50%; /* 背景图片宽度自适应，高度占据50% */
  background-repeat: no-repeat;
  //background-size: cover;  /* 让背景图片覆盖整个盒子 */
  background-position: center;
  /* 将背景图片居中 */
  //border: 1px solid #000; /* 边框样式，可选 */
}

.home {
  height: 100vh;
  overflow: auto;
  /* 启用滚动，以便内容超出屏幕高度时可以滚动 */
}

.vedio {
  width: 37em;
  height: 20em;
  background-color: aqua;
}

.vedio1 {
  width: 37em;
  height: 20em;
  //background-color: aqua;
}

.between1 {
  width: 80em;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.zipbox {
  display: flex;
  align-items: center;
  text-align: center;
  justify-con3ent: center;
  width: 30em;
  height: 6em;
  //background-color: pink;
}

.zipContent {
  display: flex;
  align-items: center;
  text-align: center;
  justify-con3ent: center;
  width: 40em;
  height: 30em;
  //background-color: skyblue;
}

.between {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.center {
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
}

.one-third {
  width: 33.333333%;
  height: 50px;
  //background-color: pink;
}

.one-forth {
  width: 25%;
  height: 6em;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  //background-color: pink;
}

//el的样式
.el-row {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

.el-col {
  border-radius: 4px;
}

.bg-purple-dark {
  background: #99a9bf;
}

.bg-purple {
  background: #d3dce6;
}

.bg-purple-light {
  background: #e5e9f2;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}

/* .el-header {
    position: absolute;
  } */
.swiper-slide {
  font-size: 24px;
  // text-align: center;
  // line-height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;

  .page {
    text-align: center;
    height: 100px;
    overflow: hidden;

    h3,
    p {
      font-size: 40px;
      font-weight: 400;
      color: #fff;
    }
  }

  .slogan {
    text-align: center;
    font-size: 50px;
    color: #fff;
    padding: 30px 0;
  }
}

//经典案例
.case-item {
  width: 1100px;
  height: 500px;
  overflow: hidden;
  margin: 0 auto;
  margin-top: 30px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;

  li {
    width: 330px;
    height: 250px;
    list-style: none;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    background-origin: content-box;
    margin: 5px;
    position: relative;
    overflow: hidden;

    &:hover {
      .case-item-hover {
        opacity: 1;
        transition: all 0.4s ease-in-out;
      }
    }
  }
}

//经典案例hover
.case-item-hover {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  overflow: hidden;
  background-color: rgba(225, 56, 52, 0.7);

  .hover-title {
    height: 50px;
    color: #fff;
    font-size: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: 400;
    margin-top: 20px;
  }

  .bottom {
    border-bottom: 1px solid #fff;
    width: 60px;
    margin: 0 auto;
  }

  .more {
    width: 90px;
    padding: 5px 5px;
    margin: 0 auto;
    margin-top: 100px;
    border: 2px solid #fff;

    span {
      color: #fff;
      font-size: 20px;
    }
  }
}

// .swiper-slide:nth-child(2n) {
//   background: skyblue;
// }
// .swiper-slide:nth-child(2n-1) {
//   background: seashell;
// }
.slide-one {
  background: url(../assets/img/home_top.jpg) no-repeat center;
  background-size: cover;
}

.slide-two {
  background: url(../assets/img/home_do.jpg) no-repeat center;
  background-size: cover;
}

.slide-three {
  background: url(../assets/img/home_anli.jpg) no-repeat center;
  background-size: cover;
}

//最新资讯
.news-content {
  width: 1240px;
  margin: 0 auto;
  margin-top: 40px;
  display: flex;
  justify-content: center;

  &-item {
    width: 400px;
    display: flex;
    flex-direction: column;

    .item-img {
      width: 360px;
      height: 230px;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      background-origin: content-box;
      margin: 0 auto;
    }

    .el-divider {
      background-color: #fff;
      height: 3px;

      .el-divider__text {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        padding: 0px;
        color: #fff;
      }
    }

    .item-content {
      width: 360px;
      height: 230px;
      margin: 0 auto;

      //border: 1px solid paleturquoise;
      h3 {
        font-size: 22px;
        height: 30px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      p {
        font-size: 15px;
        height: 80px;
        overflow: hidden;
        margin: 10px 0;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        white-space: normal !important;
        word-wrap: break-word;
      }

      span {
        display: block;
        font-size: 14px;
        text-align: end;
      }

      h3,
      p,
      span {
        color: #fff;
      }
    }
  }
}

.order {
  order: -1;
}

.order-img {
  order: 1;
}

.Upload-box .box .ckbox .layui-upload-file {
  display: block !important;
}

.disable {
  background: #999 !important;
  cursor: initial !important;
}

.hideview {
  visibility: hidden !important;
}

.del-all {
  padding: 0 25px;
  color: #e63737;
  cursor: pointer;
  z-index: 10000;
}

.cc1 {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
}

.Upload-box .box .list li .t1 {
  display: flex;
  align-items: center;
}

.Upload-box .box .list li .t1 span {
  display: block;
  width: 70%;
  width: calc(100% - 52px);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.index-box1 .box .title {
  font-size: 38px;
}

.fzq_hmban {
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 0 40px;
  margin-bottom: 16px;
}

.fzq_hmban .item {
  width: 33.333%;
  padding: 0 16px;
  color: #fff;
  text-align: center;
  display: flex;
  font-size: 16px;
  flex-direction: column;
  align-items: center;
}

.fzq_hmban .item i {
  display: block;
  height: 48px;
  overflow: hidden;
  margin-bottom: 8px;
}

.fzq_hmban .item i img {
  height: 100%;
  float: left;
}

@media (max-width: 1600px) {
  .fzq_hmban .item {
    font-size: 14px;
  }

  .index-box1 .box .title {
    font-size: 30px;
  }

  .fzq_hmban {
    padding: 0 24px;
    margin-bottom: 12px;
  }

  .fzq_hmban .item {
    padding: 0 12px;
  }

  .fzq_hmban .item i {
    height: 42px;
  }
}

@media (max-width: 1220px) {
  .fzq_hmban .item i {
    height: 38px;
  }

  .index-box1 .box .title {
    font-size: 28px;
  }

  .fzq_hmban {
    padding: 0 16px;
  }

  .fzq_hmban .item {
    padding: 0 8px;
  }
}

@media (max-width: 767px) {
  .fzq_hmban .item i {
    height: 32px;
  }

  .index-box1 .box .title {
    font-size: 20px;
  }

  .fzq_hmban {
    padding: 0 12px;
  }

  .fzq_hmban .item {
    padding: 0 5px;
  }
}

.index-box1 .box .f_text {
  font-size: 24px;
  font-size: 26px;
  display: block;
  color: #fff;
  margin-top: 16px;
  text-align: center;
}

.index-box1 .box .but {
  display: flex;
  justify-content: center;
}

.index-box1 .box .fz_but {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 36px;
  color: #fff;
  padding: 0 10px;
  min-width: 168px;
  border-radius: 24px;
  background: #48a2f8;
  font-size: 14px;
  margin: 26px auto 0;
  background-color: #fff;
  color: #48a2f8;
}


@media (max-width: 1600px) {
  .index-box1 .box .fz_but {
    min-width: 140px;
    height: 32px;
    margin-top: 22px;
  }
}

@media (max-width: 767px) {
  .index-box1 .box .fz_but {
    min-width: 120px;
    padding: 0 8px;
    margin-top: 18px;
    font-size: 12px;
  }
}

@media (max-width: 1200px) {
  .index-box1 .box .f_text {
    font-size: 20px;
    font-size: 24px;
    margin-top: 12px;
  }
}

@media (max-width: 991px) {
  .index-box1 .box .f_text {
    font-size: 16px;
    /* font-size: 16; */
  }
}

.index-box1 .box .ibox .taowa {}

.fhm-sec1 .cont .f_font .f_text a:hover {
  text-decoration: underline;
  color: #48a2f8;
}

::v-deep .custom-upload .el-upload-dragger {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
  display: block !important;
}

::v-deep .normal_upload .el-upload-dragger {
  width: 100%;
  height: 100%;
  cursor: pointer;
  border: none !important;
}

::v-deep .none_upload .el-upload-dragger {
  background-color: red;
  display: none;
}
</style>
